/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Email/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import React from 'react'
import TysiaIconArrowDown from 'DesignSystem/Svgs/TysiaIconArrowDown/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Email({
  children,
  viewPath = "/DesignSystem/PatientOverview/Content/Contact/Content/Emails/Email"
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let contactEmails0EmailAddressValueData = fromData.useDataValue({ viewPath,
context: 'contact',
path: 'emails.[0].email.address',
})
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
let contactEmailsValueData = fromData.useDataValue({ viewPath,
context: 'contact',
path: 'emails',
})
let constantData = 1
let aggregateData = fromAggregate.lengthGreaterThan(contactEmailsValueData, constantData)
let dtColorsNeutral700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.700'
        })
  return (<React.Fragment
>
<div
  data-testid="Email.Horizontal"
  data-view-path={viewPath}
 style={{'--g-1-4PsPS': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="small"
 color={dtColorsNeutral900}
 data="contact.emails.[0].email.address"
 text={contactEmails0EmailAddressValueData}
/>
<fromFlow.When is={aggregateData}>
<TysiaIconArrowDown
  viewPath={`${viewPath}/TysiaIconArrowDown`}
 height="12px"
 width="12px"
 fill2={dtColorsNeutral700}
 data="contact.emails"
 data={1}
 aggregate="/Data/aggregate.js lengthGreaterThan"
/>
</fromFlow.When>
</div>
{children}
</React.Fragment>)
}